import { FeatureFlag } from '../FeatureFlag';

/**
 * Enables insertion flashes across the ADR 0017 time-list views (News, Events and Filings).
 * App integrations pass this flag to the shared renderer; paging rows never flash.
 */
export const enableTimeListRowFlash = new FeatureFlag({
    key: 'enable-time-list-row-flash',
    createdOn: '2026-09-14',
    defaultValue: false,
});
